export const releaseTypeFilterOptions = [
  {
    label: 'Email',
    releaseType: 'email',
    releaseDay: null
  },
  {
    label: 'Deposit',
    releaseType: 'deposit',
    releaseDay: null
  },
  {
    label: 'Auto',
    children: [
      {
        label: 'Monday',
        releaseType: 'auto',
        releaseDay: 1
      },
      {
        label: 'Tuesday',
        releaseType: 'auto',
        releaseDay: 2
      },
      {
        label: 'Wednesday',
        releaseType: 'auto',
        releaseDay: 3
      },
      {
        label: 'Thursday',
        releaseType: 'auto',
        releaseDay: 4
      },
      {
        label: 'Friday',
        releaseType: 'auto',
        releaseDay: 5
      },
      {
        label: <span className='text-gray-400'>(Empty)</span>,
        releaseType: 'auto',
        releaseDay: null
      }
    ]
  },
  {
    label: 'Level Funded',
    releaseType: 'level-funded',
    releaseDay: null
  },
  {
    label: <span className='text-gray-400'>(Empty)</span>,
    releaseType: null,
    releaseDay: null
  }
]
